var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArnoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 37,
    viewBox: "0 0 48 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_1599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3858 27.4436C37.0464 27.4436 38.3927 26.0569 38.3927 24.3463C38.3927 22.6357 37.0464 21.249 35.3858 21.249C33.7251 21.249 32.3789 22.6357 32.3789 24.3463C32.3789 26.0569 33.7251 27.4436 35.3858 27.4436Z",
    fill: "#0D0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5776 27.4437C14.2382 27.4437 15.5844 26.057 15.5844 24.3464C15.5844 22.6358 14.2382 21.2491 12.5776 21.2491C10.9169 21.2491 9.57068 22.6358 9.57068 24.3464C9.57068 26.057 10.9169 27.4437 12.5776 27.4437Z",
    fill: "#0D0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0962 32.694H36.6325V37H42.0962V32.694Z",
    fill: "#01AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6325 32.6939H5.31703C4.98701 32.6939 4.69365 32.4295 4.65698 32.0896V37H36.6325V32.6939Z",
    fill: "#117BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65699 32.0141V21.5889H0V32.2407C0 34.8848 2.05348 37 4.62032 37H4.65699V32.0896C4.65699 32.0518 4.65699 32.0518 4.65699 32.0141Z",
    fill: "#01AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.4141V21.5889H4.65699V16.6408C4.65699 16.3008 4.91367 15.9986 5.2437 15.9609H0.0366692C0 16.1119 0 16.263 0 16.4141Z",
    fill: "#0092C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40032 11.6548C2.09016 11.7681 0.220028 13.619 0.0366821 15.9609H5.24371C5.28038 15.9609 5.28038 15.9609 5.31705 15.9609H37.8793V11.6548H4.40032Z",
    fill: "#0ED6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8425 11.6548V15.9609H42.6785C43.0107 15.9609 43.306 16.2253 43.3429 16.5652V11.6548H37.8425Z",
    fill: "#0CC4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5997 11.6548H43.343V16.5652C43.343 16.603 43.343 16.603 43.343 16.6408V31.4853H48V16.4141C47.9633 13.8456 46.0199 11.7681 43.5997 11.6548Z",
    fill: "#13E0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3583 5.51475V10.7845H25.0817V5.4392C26.2185 5.06148 27.0619 4.04163 27.0619 2.79515C27.0619 1.24648 25.7418 0 24.0917 0C22.4782 0 21.1215 1.24648 21.1215 2.79515C21.1581 4.11718 22.1115 5.21257 23.3583 5.51475Z",
    fill: "#01AAE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_1599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArnoldIcon);
export default __webpack_public_path__ + "static/media/arnoldIcon.349689ab46212d117dfe2c2027af3317.svg";
export { ForwardRef as ReactComponent };